class SurveyQuestionCollection extends App.Collections.BaseCollection {
    url = 'SurveyQuestion';
    model = App.Models.SurveyQuestion;
}

App.Collections.SurveyQuestions = SurveyQuestionCollection;
